import React from 'react';

function CommentIcon({
  className,
}: BaseIcon): JSX.Element {
  return (
    <svg
      viewBox="0 0 16 16"
      className={className}
    >
      <g id="ic_x5F_calendar">
        <path d="M13,6H5.5C5.224,6,5,6.224,5,6.5S5.224,7,5.5,7H13c0.276,0,0.5-0.224,0.5-0.5S13.276,6,13,6z" />
        <path d="M13,8H5.5C5.224,8,5,8.224,5,8.5S5.224,9,5.5,9H13c0.276,0,0.5-0.224,0.5-0.5S13.276,8,13,8z" />
        <path d="M13.678,3H4.813C3.532,3,2.49,4.096,2.49,5.443v2.743c-0.436,0.543-1.468,1.793-2.114,2.29 c-0.264,0.203-0.406,0.538-0.37,0.872c0.034,0.341,0.243,0.639,0.546,0.779c0.688,0.318,1.537,0.34,2.526,0.054 C3.515,12.7,4.139,13,4.813,13h8.865C14.958,13,16,11.904,16,10.557V5.443C16,4.096,14.958,3,13.678,3z M15,10.557 C15,11.353,14.407,12,13.678,12H4.813c-0.449,0-0.864-0.247-1.108-0.66c-0.093-0.155-0.258-0.245-0.431-0.245 c-0.055,0-0.111,0.009-0.165,0.028c-0.884,0.309-1.626,0.278-2.123,0.146c0.749-0.576,1.823-1.875,2.396-2.598 C3.452,8.584,3.49,8.475,3.49,8.361V5.443C3.49,4.647,4.083,4,4.813,4h8.865C14.407,4,15,4.647,15,5.443V10.557z" />
      </g>
    </svg>
  );
}

export default CommentIcon;
